import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeads, deleteLead } from "../../../../utils/redux/lead/leadActions";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { IoIosArrowDown } from "react-icons/io";
import { formatKey } from "../../../../helpers/formatKey";

const LeadListingPage = () => {
    const dispatch = useDispatch();
    const { leads } = useSelector(state => state.lead);

    const [filters, setFilters] = useState({
        profile: "",
        request_type: ""
    });

    const [openRow, setOpenRow] = useState(null);

    useEffect(() => {
        dispatch(fetchLeads(filters));
    }, [filters]);

    const handleDelete = async (id) => {
        if (!window.confirm("Delete lead?")) return;

        const res = await dispatch(deleteLead(id));
        if (res?.success) toast.success("Deleted");
    };

    return (
        <div className="container">

            {/* HEADER */}
            <div className="d-flex justify-content-between my-4">
                <h3>Leads</h3>
            </div>

            {/* FILTERS */}
            <div className="row mb-3">
                <div className="col-md-3">
                    <select
                        className="form-select"
                        onChange={e =>
                            setFilters(prev => ({
                                ...prev,
                                profile: e.target.value
                            }))
                        }
                    >
                        <option value="">All Profiles</option>
                        <option value="AID">AID</option>
                        <option value="HOTELIER">Hotelier</option>
                        <option value="HOMEOWNER">Homeowner</option>
                    </select>
                </div>

                <div className="col-md-3">
                    <select
                        className="form-select"
                        onChange={e =>
                            setFilters(prev => ({
                                ...prev,
                                request_type: e.target.value
                            }))
                        }
                    >
                        <option value="">All Requests</option>
                        <option value="NORMAL">Normal</option>
                        <option value="LEARNING_CIRCLE">Learning Circle</option>
                        <option value="STUDIO">Studio</option>
                    </select>
                </div>
            </div>

            {/* TABLE */}
            <table className="table table-sm align-middle">
                <thead className="table-secondary">
                    <tr>
                        <th>Name</th>
                        <th>Profile</th>
                        <th>Request</th>
                        <th>Phone</th>
                        <th>Actions</th>
                    </tr>
                </thead>

                <tbody>
                    {leads?.length ? (
                        leads.map((l, index) => (
                            <React.Fragment key={l._id}>

                                {/* MAIN ROW */}
                                <tr
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                        setOpenRow(openRow === index ? null : index)
                                    }
                                >
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <span
                                                className="me-2"
                                                style={{
                                                    transform:
                                                        openRow === index
                                                            ? "rotate(180deg)"
                                                            : "rotate(0deg)",
                                                    transition: "0.2s"
                                                }}
                                            >
                                                <IoIosArrowDown />
                                            </span>

                                            <Link
                                                to={`/leads/${l._id}`}
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                {l.first_name} {l.last_name}
                                            </Link>
                                        </div>
                                    </td>

                                    <td>{l.profile}</td>
                                    <td>{l.context?.request_type}</td>
                                    <td>{l.phone}</td>

                                    <td>
                                        <button
                                            className="btn btn-sm text-danger"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDelete(l._id);
                                            }}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>

                                {/* EXPANDED ROW */}
                                {openRow === index && (
                                    <tr>
                                        <td colSpan="5" className="bg-light">

                                            {/* BASIC INFO */}
                                            <div className="mb-3">
                                                <strong>Email:</strong> {l.email || "-"}
                                            </div>

                                            {/* METADATA */}
                                            {l.context?.metadata ? (
                                                <table className="table table-sm mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Field</th>
                                                            <th>Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.entries(l.context.metadata).map(
                                                            ([key, value], i) => (
                                                                <tr key={i}>
                                                                    <td>{formatKey(key)}</td>
                                                                    <td>
                                                                        {typeof value === "object"
                                                                            ? JSON.stringify(value)
                                                                            : value?.toString()}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <div className="text-muted">
                                                    No metadata available
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="5" className="text-center text-muted">
                                No leads found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default LeadListingPage;